import { render, staticRenderFns } from "./GrnCreate.vue?vue&type=template&id=6aa6a20e&scoped=true&"
import script from "./GrnCreate.vue?vue&type=script&lang=js&"
export * from "./GrnCreate.vue?vue&type=script&lang=js&"
import style0 from "./GrnCreate.vue?vue&type=style&index=0&id=6aa6a20e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa6a20e",
  null
  
)

export default component.exports